import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './PrivateCloud.css';
import Header from "../../components/Common/Header/Header";
import Footer from '../../components/Common/Footer/Footer';
import IntroSectionPrivateCloud from '../../components/PrivateCloud/IntroSectionPrivateCloud/IntroSectionPrivateCloud';
import IntroSectionPrivateCloud2 from '../../components/PrivateCloud/IntroSectionPrivateCloud/IntroSectionPrivateCloud2';
import IntroSectionPrivateCloud3 from '../../components/PrivateCloud/IntroSectionPrivateCloud/IntroSectionPrivateCloud3';
import Navbar from "../../components/Common/Navbar/Navbar";
import ExpertiseSection from '../../components/PrivateCloud/ExpertiseSectionPrivateCloud/ExpertiseSectionPrivateCloud';
import IntroSectionBottom from '../../components/Common/IntroSectionBottom/IntroSectionBottom';
import introSectionData3 from '../../components/Common/IntroSectionBottom/introSectionData3';
import useSectionRefs from '../../hooks/useSectionRefs';
import TimelinePrivateCloud from '../../components/PrivateCloud/ServicesCardsPrivateCloud/TimelinePrivateCloud';
import ContactLinkSection from '../../components/Common/ContactLinkSection/ContactLinkSection';
import { GridPatternCard, GridPatternCardBody } from '../../components/ui/card-with-ellipsis-pattern';
import PricingSectionAzurePrivateCloud from '../../components/ui/pricing-section-azure-privatecloud';

const PrivateCloud: React.FC = () => {
  const { t } = useTranslation();
  const sectionRefs = useSectionRefs();  
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const handleOpenContactModal = () => {
    setIsContactModalOpen(true);
  };

  const handleCloseContactModal = () => {
    setIsContactModalOpen(false);
  };

    return (
    <div>
      <div>
      <section id="header" className="section dark" ref={sectionRefs.header}>
        <div>
          <Navbar 
            sectionRefs={sectionRefs}
            openContactModal={handleOpenContactModal}
            closeContactModal={handleCloseContactModal}
          />
          <Header 
            title={t('privateCloud.header.title', { defaultValue: 'Cloud privé sur NAS' })} 
            subtitle={t('privateCloud.header.subtitle', { defaultValue: 'Offrez à votre entreprise la liberté et la sécurité d\'un cloud privé.' })} 
          />
        </div>
      </section>
      <section id="start" className="section light" ref={sectionRefs.start}>
        <IntroSectionPrivateCloud />
      </section>

      <section id="commitment" className="section light commitment-section" ref={sectionRefs.commitment}>
        <IntroSectionPrivateCloud3 />
      </section>

      <section id="cloud" className="section dark" ref={sectionRefs.cloud}>
        <IntroSectionPrivateCloud2 />
      </section>

      <section id="services" className="section light" ref={sectionRefs.services}>
        <IntroSectionBottom data={introSectionData3} translationNamespace="privateCloud" />
      </section>
        <div className="gradient-bg">
      <section id="start2" className="section light" ref={sectionRefs.start2}>
        <PricingSectionAzurePrivateCloud openContactModal={handleOpenContactModal} />
      </section>
          <div className="gradient-bg">
            <section
              id="expertise"
              className="section dark"
              ref={sectionRefs.expertise}
            >
          <TimelinePrivateCloud />
          <GridPatternCard>
            <GridPatternCardBody>
              <div className="tw-h-[5em]"></div>
            </GridPatternCardBody>
          </GridPatternCard>
          </section>
        </div>
      <section id="newsletter" className="section dark" ref={sectionRefs.newsletter}>
      <ContactLinkSection pageKey="privateCloud" />
        <Footer />
      </section>
    </div>
    </div>
    </div>
  );
};

export default PrivateCloud;
